import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Tooltip
} from '@material-ui/core';
import { Close, Help } from '@material-ui/icons';
import styled from 'styled-components';

import TourProcessingForm from '../../../components/tour/TourProcessing/TourProcessingForm';

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 1200px;
    width: 95vw;
    max-height: 90vh;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  padding: 0;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CustomAlert = styled.div`
  padding: 16px;
  border-radius: 4px;
  margin: 16px;
  
  ${props => props.severity === 'error' && `
    background-color: ${props.theme && props.theme.palette ? props.theme.palette.error.light : '#ffebee'};
    color: ${props.theme && props.theme.palette ? props.theme.palette.error.contrastText : '#c62828'};
    border: 1px solid ${props.theme && props.theme.palette ? props.theme.palette.error.main : '#f44336'};
  `}
  
  ${props => props.severity === 'warning' && `
    background-color: ${props.theme && props.theme.palette ? props.theme.palette.warning.light : '#fff3e0'};
    color: ${props.theme && props.theme.palette ? props.theme.palette.warning.contrastText : '#ef6c00'};
    border: 1px solid ${props.theme && props.theme.palette ? props.theme.palette.warning.main : '#ff9800'};
  `}
  
  ${props => props.severity === 'info' && `
    background-color: ${props.theme && props.theme.palette ? props.theme.palette.info.light : '#e3f2fd'};
    color: ${props.theme && props.theme.palette ? props.theme.palette.info.contrastText : '#1565c0'};
    border: 1px solid ${props.theme && props.theme.palette ? props.theme.palette.info.main : '#2196f3'};
  `}
`;

/**
 * Modal wrapper para el formulario de procesamiento de tours
 */
const TourProcessingModal = ({
  open,
  onClose,
  tourId,
  tourData = null,
  mode = "pending",
  onSuccess,
  onError
}) => {
  const [notification, setNotification] = useState(null);

  const handleSuccess = (data) => {
    setNotification({
      type: 'success',
      message: `Tour procesado exitosamente`
    });
    if (onSuccess) {
      onSuccess(data);
    }
  };

  const handleError = (error) => {
    setNotification({
      type: 'error',
      message: `Error al procesar el tour: ${error.message}`
    });
    if (onError) {
      onError(error);
    }
  };

  const handleClose = () => {
    setNotification(null);
    onClose();
  };

  return (
    <StyledDialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <TitleContainer>
          <Typography variant="h5">
            {mode === "pending" ? "Procesar Tour Pendiente" : "Procesar Tour Confirmado"}
          </Typography>
          <div>
            <Tooltip title="Ayuda">
              <IconButton size="small">
                <Help fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Cerrar">
              <IconButton onClick={handleClose} size="small">
                <Close fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        </TitleContainer>
      </DialogTitle>

      <StyledDialogContent>
        {/* Notificaciones */}
        {notification && (
          <CustomAlert severity={notification.type}>
            <Typography variant="body2">
              {notification.message}
            </Typography>
          </CustomAlert>
        )}

        {/* Formulario de procesamiento */}
        <TourProcessingForm
          open={true}
          onClose={handleClose}
          tourId={tourId}
          tourData={tourData}
          mode={mode}
          onSuccess={handleSuccess}
          onError={handleError}
        />
      </StyledDialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cerrar
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default TourProcessingModal; 


// WEBPACK FOOTER //
// ./src/features/tours/components/TourProcessingModal.js